import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_FormCheckBox = _resolveComponent("FormCheckBox");
    const _component_FormWrapper = _resolveComponent("FormWrapper");
    const _component_FormElementDescription = _resolveComponent("FormElementDescription");
    return (_openBlock(), _createElementBlock("span", null, [
        _createVNode(_component_FormWrapper, { cls: "border-0" }, {
            default: _withCtx(() => [
                _createVNode(_component_FormCheckBox, {
                    modelValue: _ctx.val.molsToConsider.visible,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.val.molsToConsider.visible) = $event)),
                    text: 'Consider visible ' + _ctx.molNameToUse,
                    id: "visMols",
                    class: "mt-2"
                }, null, 8, ["modelValue", "text"]),
                _createVNode(_component_FormCheckBox, {
                    modelValue: _ctx.val.molsToConsider.selected,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.val.molsToConsider.selected) = $event)),
                    text: 'Consider selected ' + _ctx.molNameToUse,
                    id: "selMols"
                }, null, 8, ["modelValue", "text"]),
                _createVNode(_component_FormCheckBox, {
                    modelValue: _ctx.val.molsToConsider.hiddenAndUnselected,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.val.molsToConsider.hiddenAndUnselected) = $event)),
                    text: 'Consider other ' +
                        _ctx.molNameToUse +
                        ' (hidden and unselected)',
                    id: "otherMols"
                }, null, 8, ["modelValue", "text"]),
                (_ctx.val.considerProteins && _ctx.val.allowUserToToggleIncludeMetalsSolventAsProtein)
                    ? (_openBlock(), _createBlock(_component_FormCheckBox, {
                        key: 0,
                        modelValue: _ctx.val.includeMetalsSolventAsProtein,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.val.includeMetalsSolventAsProtein) = $event)),
                        text: "Count metals/solvent as part of the protein",
                        id: "countMetalsSolvent"
                    }, null, 8, ["modelValue"]))
                    : _createCommentVNode("", true)
            ]),
            _: 1
        }),
        _createVNode(_component_FormElementDescription, { description: _ctx.summary }, null, 8, ["description"])
    ]));
}
